import Game from './scenes/Game';
import Intro from './scenes/Intro';

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [Intro, Game],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: Intro.KEY,
  currentScene: 'Intro', // "Intro", "Game"
  gameMode: 'letters', // 'all', 'letters'
  gameStyle: 'Lava', // 'Classic', 'Lava', 'Rnbow', 'SciFi', 'Slime', 'Wood'
  gameOver: false,
  gamePaused: false,
  gameMuted: false,
  hideNav: true,
  bestAll: 0,
  bestLetters: 0,
  tries: 0,
  placementCounter: 0, // 0 base
  anim: null,
  particleAtlas: 'particles',
  maxKeys: (mode) => {
    if (mode === 'letters') return 36;
    if (mode === 'all') return 60;
  },

  layout: [
    ['Tilde', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'Hyphen', 'Equal', 'Delete'],
    ['Tab', 'Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P', 'BracketL', 'BracketR', 'Backslash'],
    ['Caps', 'A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'Semicolon', 'Apostrophe', 'Return'],
    ['ShiftL', 'Z', 'X', 'C', 'V', 'B', 'N', 'M', 'Comma', 'Period', 'Forslash', 'ShiftR'],
    ['CtrlL', 'OptionL', 'AltL', 'Space', 'AltR', 'OptionR', 'CtrlR']
  ],

  layoutLess: [
    ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
    ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
    ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
    ['Z', 'X', 'C', 'V', 'B', 'N', 'M']
  ],

  letterNumbers: [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '0',
    'Q',
    'W',
    'E',
    'R',
    'T',
    'Y',
    'U',
    'I',
    'O',
    'P',
    'A',
    'S',
    'D',
    'F',
    'G',
    'H',
    'J',
    'K',
    'L',
    'Z',
    'X',
    'C',
    'V',
    'B',
    'N',
    'M'
  ],

  symbols: [
    'Tilde',
    'Hyphen',
    'Equal',
    'Delete',
    'Tab',
    'BracketL',
    'BracketR',
    'Backslash',
    'Caps',
    'Semicolon',
    'Apostrophe',
    'Return',
    'ShiftL',
    'Comma',
    'Period',
    'Forslash',
    'ShiftR',
    'CtrlL',
    'OptionL',
    'AltL',
    'Space',
    'AltR',
    'OptionR',
    'CtrlR'
  ],

  shuffledKeys: [
    ['7', 'Comma', 'Z', 'U', 'P', 'BracketL', 'M', 'ShiftR', 'Tilde', '1', 'H', 'OptionL'],
    ['CtrlR', 'A', 'X', '6', 'Caps', 'Equal', 'W', 'R', 'BracketR', 'Forslash', 'Semicolon', 'S', 'Q', 'V'],
    ['4', 'Space', 'N', 'L', 'AltR', 'OptionR', 'T', '5', '2'],
    ['Return', 'AltL', '8', 'Tab', 'CtrlL', 'Apostrophe', 'Hyphen', 'Delete', '9', 'Y', 'Period', 'D'],
    ['J', 'B', '3', 'G', 'E', 'Backslash', 'F', 'O', 'ShiftL', 'I', '0', 'C', 'K']
  ],

  shuffledLesserKeys: [
    ['1', '3', 'U', 'I', 'E', 'A', 'L', 'H', 'V'],
    ['5', '7', '9', 'Q', 'O', 'S', 'X', 'B', 'M'],
    ['6', '2', '0', 'W', 'P', 'D', 'J', 'C', 'N'],
    ['8', '4', 'R', 'T', 'Y', 'F', 'G', 'Z', 'K']
  ],
};
